import React from "react";

export default ({ userData, children }) => (
  <div className="SubPage">
    <div className="SubPage_body">
      {React.cloneElement(children, { userData })}
    </div>
  </div>
);
